import { useQuery } from "@tanstack/react-query";
import { getAlerts } from "../../../api/alertsApi";
import { AlertItem } from "../../../pages/Alerts/alertsMockData";

export const ALERTS_QUERY_KEY = ["alerts"];

// Shared by the Alerts page and every DashboardAlertWidget instance - react-query's own cache
// (keyed on ALERTS_QUERY_KEY) is what gives them a shared cache instead of double-fetching, which
// is exactly what FRONTEND_TASKS.md's proposed AlertsContext was for. No separate Context is
// needed on top of react-query's own per-query-key caching.
export const useAlerts = () => {
  const { data, isLoading } = useQuery<AlertItem[]>(ALERTS_QUERY_KEY, getAlerts);
  return { alerts: data ?? [], isLoading };
};
